var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChampion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "606px",
    height: "607.439px",
    viewBox: "220.578 78.363 606 607.439",
    enableBackground: "new 220.578 78.363 606 607.439",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M678.063,79.313c-14.224,4.391-24.058,18.037-24.058,33.338c0,23.484,23.115,39.969,45.511,32.62 c9.13-3.083,18.844-12.933,21.692-22.422c6.995-22.297-9.479-44.724-32.474-44.484C684.464,78.365,679.724,78.838,678.063,79.313z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 556,
    y: 81.333,
    width: 270.578,
    height: 604.468
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M561.558,84.172c-3.672,2.969-6.047,9.609-4.979,14c0.479,2.13,16.474,18.979,45.755,48.281l44.917,45.078l-0.234,123.963 l-0.359,123.969l-17.427,0.354l-17.542,0.359v245.433h162.375V440.058l-19.198-0.24l-19.317-0.354l-0.359-123.969l-0.234-123.838 l45.042-45.198c38.755-38.912,45.156-45.792,45.75-49.344c0.828-4.87-1.662-10.563-5.688-13.406 c-3.084-2.255-10.667-2.49-14.344-0.474c-1.422,0.708-18.964,16.963-38.995,36.057c-45.156,42.943-39.109,39.859-76.683,39.38 c-35.438-0.474-31.76,1.307-67.197-32.505c-51.558-49.224-45.87-44.359-52.5-44.359C566.422,81.807,563.688,82.516,561.558,84.172 z M695.604,377.537l0.239,62.63l-4.386-0.359l-4.505-0.359l-0.359-61.089c-0.114-33.573,0-61.807,0.359-62.635 c0.359-0.948,2.016-1.422,4.386-1.188l3.911,0.359L695.604,377.537z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 414.667,
    y: 521.333,
    width: 164,
    height: 164.469
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_4_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.948,603.745v81.854h163.563l-0.24-81.609l-0.354-81.494l-81.422-0.359l-81.542-0.234v81.844H414.948z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 220.578,
    y: 601.333,
    width: 163.422,
    height: 84.469
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_6_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.578,644.078v41.521h162.375v-83.041H220.578V644.078z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.503069, 15.650058)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(125.703719, 15.650058)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(168.513592, 15.650058)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(209.956595, 15.650058)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChampion);
export default __webpack_public_path__ + "static/media/champion.16bee1f6ca2e29a777501211c69ab467.svg";
export { ForwardRef as ReactComponent };